import { render, staticRenderFns } from "./HotelMinPriceButton.vue?vue&type=template&id=687ebfe8&"
import script from "./HotelMinPriceButton.vue?vue&type=script&lang=ts&"
export * from "./HotelMinPriceButton.vue?vue&type=script&lang=ts&"
import style0 from "./HotelMinPriceButton.vue?vue&type=style&index=0&id=687ebfe8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports